import MojitoCore from 'mojito/core';
import DataProvidersTypes from 'services/sports-content/content-provider/types.js';

const DataProvider = MojitoCore.Services.DataProvider;
const {
    TournamentProvider: { COLLECTION_NAME },
} = DataProvidersTypes;

/**
 *
 * Class offering the possibility to link to specific tournament payloads.
 *
 * @class TournamentProvider
 * @extends Mojito.Core.Services.DataProvider
 * @memberof Mojito.Services.SportsContent.DataProviders
 */
class TournamentProvider extends DataProvider {
    init(languageCode) {
        super.addSimpleCollection(COLLECTION_NAME, languageCode);
    }

    subscribeToEntity(tournamentId, onUpdate) {
        return super.subscribeToEntity(tournamentId, onUpdate, COLLECTION_NAME);
    }

    subscribeToEntities(tournamentIds, onInit, onUpdate) {
        return super.subscribeToEntities(tournamentIds, onInit, onUpdate, COLLECTION_NAME);
    }
}

export default new TournamentProvider();
